import React from 'react'
import { StyleSheet } from 'react-native'
import * as Linking from 'expo-linking'
import MarkdownRenderer from 'react-native-markdown-display'

import * as colors from '../../config/colors'
import * as v from '../../config/variables'

type Props = {
  // styles?: unknown
  children?: React.ReactNode
  content?: string
}

const markdownStyles = StyleSheet.create({
  body: {
    fontFamily: v.FONT_FAMILY_BASE,
    fontSize: v.FONT_SIZE_BASE,
  },
  text: {
    fontSize: v.FONT_SIZE_BASE,
  },
  strong: {
    fontFamily: v.FONT_FAMILY_BOLD,
  },
  em: {
    fontFamily: 'NunitoSans_400Regular_Italic',
  },
  heading1: {
    fontFamily: v.FONT_FAMILY_BOLD,
    fontSize: v.FONT_SIZE_H1,
    color: colors.blue,
    marginVertical: v.SPACE_SM,
  },
  heading2: {
    fontFamily: v.FONT_FAMILY_BOLD,
    fontSize: v.FONT_SIZE_H2,
    color: colors.blue,
    marginVertical: v.SPACE_SM,
  },
  heading3: {
    fontFamily: v.FONT_FAMILY_BOLD,
    fontSize: v.FONT_SIZE_H3,
    color: colors.blue,
    marginVertical: v.SPACE_SM,
  },
  // list: {
  //   marginBottom: v.SPACE_SM,
  // },
  bullet_list_icon: {
    color: colors.blue,
  },
  link: {
    color: colors.blue,
    borderWidth: 0,
  },
})

const Markdown = (props: Props) => {
  const { children, content } = props
  return (
    <MarkdownRenderer
      style={markdownStyles}
      onLinkPress={(url) => Linking.openURL(url)}
    >
      {content || children}
    </MarkdownRenderer>
  )
}

export default Markdown
